// extracted by mini-css-extract-plugin
module.exports = {"card":"ReminderList_card__7dLPm","reminder-scanline":"ReminderList_reminder-scanline___e_jI"};